/**
 * Advance Search Filter View
 * @author hvillarreal
 *
 */
import $ from 'jquery';
import BaseView from 'BaseView';
import trackLink from 'view/activity/trackLink';
import 'bootstrap-dropdown';
import 'bootstrap-tooltip';
import 'bootstrap-popover';

export default BaseView.extend({
	el: '.js_advancedSearch',

	template: 'activity/inc/advancedSearch',

	events: {
		'click .js_advancedSearch-link': 'openFilterDropdown', // opening advanced search popover
		'click .js_filters-control-transactionFilter': 'selectTransactionFilter', // selecting a txn filter
		'click .js_filters-control-currencyFilter': 'selectCurrencyFilter', // selecting a currency filter
		'keydown .js_filters-control-transactionFilter': 'selectTransactionFilter', // selecting a txn filter with enter key
		'keydown .js_filters-control-currencyFilter': 'selectCurrencyFilter' // selecting a currency filter
	},

	initialize(options) {
		// get visibility of our parent (filter view) so we can have access to
		// 'onFilterView' since we rely on it heavily
		this.filterView = options.parent;

		this.listenTo(this.model, 'change:currencyCodes', this.recreatePopover);

		this.render();
	},

	createPopover () {
		let self = this;

		$(function () {
			let $advancedTrigger = self.$('#js_advancedSearchPopover');
			let $advancedFocusTrigger = $advancedTrigger.parent(); // need to target parent for FF & IE

			$advancedTrigger.popover({
				placement: 'bottom', //placement of the popover. also can use top, bottom, left or right
				html: 'true', //needed to show html of course
				content: self.$('#js_filterList').detach().html(), // Html code for filter list,
				trigger: 'manual' // Manually manage focus to allow for tabbing into popover.
			});

			$advancedTrigger.on('mousedown', (event) => {
				event.preventDefault(); // prevents focus from firing
				$advancedTrigger.popover('toggle');
			});

			$advancedFocusTrigger.on('focus', (event) => {
				$advancedTrigger.popover('show');
				self.openFilterDropdown(event);
			});

			$advancedTrigger.on('shown.bs.popover', function () {
				let $popover = $advancedTrigger.next('.popover');
				$popover[0].addEventListener('blur', closeIfPopoverDoesNotContainFocus, true);
				$advancedFocusTrigger[0].addEventListener('blur', closeIfPopoverDoesNotContainFocus, true);
				trackLink('openadvancedfilters');
			});

			$advancedTrigger.on('hidden.bs.popover', function () {
				trackLink('closedadvancedfilters');
			});

			function closeIfPopoverDoesNotContainFocus(event) {
				setTimeout(() => {
					let popover = $advancedTrigger.data('bs.popover');
					if (popover && popover.$tip[0] && !$.contains(popover.$tip[0], document.activeElement)) {
						self.closeFilterDropdown(event);
					}
				}, 0);
			}

			// Close the popover if user clicks outside popover area if the popover is open
			$('body').on('click', function (event) {
				let popoverIsOpen = $('#js_advancedSearchPopover').next('div.popover:visible').length;
				if (popoverIsOpen) {
					self.$('#js_advancedSearchPopover').each(function () {
						//the 'is' for buttons that trigger popups
						//the 'has' for icons within a button that triggers a popup
						if (!$(this).is(event.target) && $(this).has(event.target).length === 0 && $('.popover').has(event.target).length === 0) {
							self.closeFilterDropdown(event);
						}
					});
				}
			});

		});
	},

	/*
	 * If there is a change to currency codes we destroy the advance search popover
	 * and call render() so that we can get updated content and create a new popover
	 */
	recreatePopover (event) {
		this.$('#js_advancedSearchPopover').popover('destroy');
		this.render();
	},

	afterRender () {
		this.createPopover();
	},

	/**
	 * Handle transaction filter search
	 */
	triggerFilterSearch (event) {
		this.filterView.onFilterView(event);
		this.closeFilterDropdown(event);
	},

	/**
	 * Persist the selected transaction type to the model
	 */
	selectTransactionFilter (event) {
		if (event.keyCode && event.keyCode === 13 || !event.keyCode) {
			let inputEl = $(event.currentTarget).find('.js_filterOption');
			if (inputEl) {
				let txnFilter = inputEl.val();
				this.model.set('isClientSideFiltering', true);
				this.model.set('isClearFilterSelection', false);
				this.model.set('transactionFilter', txnFilter);
				this.model.triggerTxnFilterFPTI(txnFilter, true);
				this.triggerFilterSearch(event);
			}
		}
	},

	/**
	 * Persist the selected currency to the model
	 */
	selectCurrencyFilter (event) {
		if (event.keyCode && event.keyCode === 13 || !event.keyCode) {
			let inputEl = $(event.currentTarget).find('.js_filterOption');
			if (inputEl) {
				let currencyFilter = inputEl.val();
				this.model.set('isClientSideFiltering', true);
				this.model.set('isClearFilterSelection', false);
				this.model.set('selectedCurrency', currencyFilter);
				this.model.triggerTxnFilterFPTI(currencyFilter, true);
				this.triggerFilterSearch(event);
			}
		}
	},

	/**
	 * Close advanced search popover
	 */
	closeFilterDropdown (event) {
		this.$('#js_advancedSearchPopover').popover('hide');
	},

	/**
	 * Open advanced search popover setup
	 */
	openFilterDropdown (event) {
		event.preventDefault();
		this.highlightSelectedCurrency(event);
		this.highlightSelectedTxnType(event);
	},

	/**
	 * Highlights selected currency in selector
	 */
	highlightSelectedCurrency (event) {
		let selectedCurrency = this.model.get('selectedCurrency'),
			isChecked = false;

		if (selectedCurrency) {
			$('.js_filters-control-currencyFilter').each(function() {
				let currencySelectorInput = $(this).find('.js_filterOption')[0];
				let attrib = $(currencySelectorInput).attr('value');
				if (selectedCurrency === attrib && !isChecked) {
					isChecked = true;
					$(this).addClass('advancedSearch-txnTypeOvalActive');
				}
			});
		}
	},

	/**
	 * Highlight selected txn filter in selector
	 */
	highlightSelectedTxnType (event) {
		let selectedFilters = this.model.get('transactionFilter'),
			isChecked = false;

		if (selectedFilters) {
			$('.js_filters-control-transactionFilter').each(function() {
				let txnTypeInput = $(this).find('.js_filterOption')[0];
				let attrib = $(txnTypeInput).attr('value');
				if (selectedFilters === attrib && !isChecked) {
					isChecked = true;
					$(this).addClass('advancedSearch-txnTypeOvalActive');
				}
			});
		}
	}
});



// WEBPACK FOOTER //
// ./view/activity/filters/advancedSearchView.es6